import React from 'react';

const TermsAndConditions = () => {
  const text = 'This is placeholder for terms and conditions.';
  return <p>{text}</p>;
};

export default TermsAndConditions;
